// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import {os} from './utils/tool'
import router from './router'
import "babel-polyfill"
//scss
import './assets/scss/init.scss'
import config from './config'

//神策
import sa from './utils/shence'
//注册到vue全局
Vue.prototype.sa=sa
//开启debug模式
Vue.config.debug = true
Vue.config.productionTip = false
//安卓点点下载链接
Vue.prototype.diandianAndroidDownLoadUrl='https://dd-cms.zhongan.com/apkManagerAction/redirectLoadApk?key=071626cb702d4283b1d7a123b167031a&a=1.apk'

//注册全局组件
import Loading from './components/v_loading/index.js'
Vue.use(Loading, {container: '#app'})
import Toast from './components/v_toast/index.js'
Vue.use(Toast, {container: '#app'})

import storage from './storage/storage.js'
Vue.prototype.$storage = storage

import MetaInfo from 'vue-meta-info'
Vue.use(MetaInfo)

Vue.use(DurexCaptchaJs.default, {
    baseURL: config.API_DUREX
})

router.beforeEach((to, from, next) => {
    /* must call `next` */
    window.scrollTo(0,0)
    if(to.name === null){
        if (os().isIos || os().isAndroid || os().isTablet) {
            router.replace('/flatindexmobile')
            // window.location.href=window.location.protocol + '//' + window.location.host + window.location.pathname + 'flatindexmobile'
        } else {
            router.replace('/flatindex')
            // window.location.href=window.location.protocol + '//' + window.location.host + window.location.pathname + 'flatindex'
        }
    }
    // console.log(from,'from');
    // console.log(to,'to');
    next()
})

/* eslint-disable no-new */
new Vue({
    el:'#app',
	router,
	template: '<App/>',
	components: {
		App
	}
    // mounted() {
    //     document.dispatchEvent(new Event('render-event'))
    // }
})



// WEBPACK FOOTER //
// ./src/main.js